import * as React from "react";
import { forwardRef } from "react";
const SuccessIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#30A66F"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18.725 7.59106c.3424.32121.3595.85913.0383 1.20148l-7.7036 8.21056c-.3198.3408-.8548.3595-1.19762.0418l-3.49254-3.2362c-.34434-.319-.36483-.8568-.04576-1.2012.31907-.3443.85687-.3648 1.20121-.0457l2.87291 2.662 7.1257-7.59447c.3212-.34234.8591-.35948 1.2014-.03827",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(SuccessIcon);
export { ForwardRef as SuccessIcon };